 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { renderTextArea, renderCheckBox, renderTimePicker } from '../../../../components/reduxFields';
import { Field, reduxForm } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
    };
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentWillMount() {
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });
        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
        });
      }
    }
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p> */}
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p>
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Therapy Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>                           
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Present during session</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ParentsOrGuardian"
                    label="Parents/ Guardian"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BCBAOrBCaBA"
                    label="BCBA/ BCaBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SiblingsOrPeer"
                    label="Siblings/ Peer"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BT"
                    label="BT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>  
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Client"
                    label="Client"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                              
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Direction of Technician</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObserveTechnicianImplementing"
                    label="Observe technician implementing most recent protocol modification"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProvideCorrectiveFeedback"
                    label="Provide corrective feedback"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProvideConfirmationFeedback"
                    label="Provide confirmation feedback about treatment"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Protocols modified during session</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IncreaseOrChangeTarget"
                    label="Increase / change target"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ChangePromptLevelPromptingProcedure"
                    label="Change prompt level / prompting procedure"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TreatmentGoals"
                    label="Treatment goals"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcers"
                    label="Reinforcers"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ScheduleOfReinforcement"
                    label="Schedule of reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DiscriminativeStimulus"
                    label="Discriminative stimulus"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Materials"
                    label="Materials"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12'>
                  <Field
                    name="ObservationsToDetermineProtocols"
                    type="text"
                    fullWidth={true}
                    label="Observations to determine protocols are effective"
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Implementation by BCBA</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TestModifiedProtocol"
                    label="Test modified protocol"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BaselineOrProbeNewProtocol"
                    label="Baseline/ probe new protocol"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ModelModifiedProtocol"
                    label="Model modified protocol"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12'>
                  <Field
                    name="ParentOrCaregiverTraining"
                    type="text"
                    fullWidth={true}
                    label="Parent/Caregiver Training"
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12'>
                  <Field
                    name="AssessmentOrTreatmentAndPlanning"
                    type="text"
                    fullWidth={true}
                    label="Assessment/ Treatment and Planning"
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
              <div className='col-sm-12'>
                <Field
                  name="Notes"
                  type="text"
                  fullWidth={true}
                  label="Summary/Plan of action (if needed)"
                  // autoHeight={true}
                  rows={8}
                  disabled={true}
                  component={renderTextArea}
                />
              </div>

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
    if (state.patient.singleEncounter.sessionNotes_BCBA_BESTABA) {
      //initialData['notes'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.notes;      
      initialData['Notes'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.notes;
      initialData['ObservationsToDetermineProtocols'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.observationsToDetermineProtocols;
      initialData['ParentOrCaregiverTraining'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.parentOrCaregiverTraining;
      initialData['AssessmentOrTreatmentAndPlanning'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.assessmentOrTreatmentAndPlanning;
      // bcbA_PresentDuringSession_BESTABA
      initialData['ParentsOrGuardian'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.parentsOrGuardian;
      initialData['BCBAOrBCaBA'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.bcbaOrBCaBA;
      initialData['SiblingsOrPeer'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.siblingsOrPeer;
      initialData['BT'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.bt;
      initialData['Client'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_PresentDuringSession_BESTABA.client;                
      // bcbA_DirectionOfTechnician_BESTABA
      initialData['ObserveTechnicianImplementing'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_DirectionOfTechnician_BESTABA.observeTechnicianImplementing;
      initialData['ProvideCorrectiveFeedback'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_DirectionOfTechnician_BESTABA.provideCorrectiveFeedback;
      initialData['ProvideConfirmationFeedback'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_DirectionOfTechnician_BESTABA.provideConfirmationFeedback;
      
      // bcbA_ProtocolsModifiedDuringSession_BESTABA
      initialData['IncreaseOrChangeTarget'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.increaseOrChangeTarget;
      initialData['ChangePromptLevelPromptingProcedure'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.changePromptLevelPromptingProcedure;
      initialData['TreatmentGoals'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.treatmentGoals;
      initialData['Reinforcers'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.reinforcers;
      initialData['ScheduleOfReinforcement'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.scheduleOfReinforcement;
      initialData['DiscriminativeStimulus'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.discriminativeStimulus;
      initialData['Materials'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ProtocolsModifiedDuringSession_BESTABA.materials;
      
      // bcbA_ImplementationByBCBA_BESTABA
      initialData['TestModifiedProtocol'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ImplementationByBCBA_BESTABA.testModifiedProtocol;
      initialData['BaselineOrProbeNewProtocol'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ImplementationByBCBA_BESTABA.baselineOrProbeNewProtocol;
      initialData['ModelModifiedProtocol'] = state.patient.singleEncounter.sessionNotes_BCBA_BESTABA.bcbA_ImplementationByBCBA_BESTABA.modelModifiedProtocol;

    }
    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  return {
    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounters })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/SessionNotes_Encounter_BCBA_BESTABA.js